import React from 'react';

const PhoneContext = React.createContext({})

export default PhoneContext
